import React from 'react';
import { Typography } from '@mui/material';
import { useResponsiveFontSize } from './hooks';

interface MetricSeparatorProps {
  compact?: boolean;
}

export const MetricSeparator: React.FC<MetricSeparatorProps> = ({
  compact = false,
}) => {
  const { responsiveFontSizes } = useResponsiveFontSize(compact);

  return (
    <Typography
      variant="h2"
      fontStyle="italic"
      fontWeight={400}
      sx={(theme) => ({
        fontSize: responsiveFontSizes,
        color: theme.palette.text.second,
        marginBottom: 2,
        marginRight: {
          xs: theme.spacing(1),
          sm: theme.spacing(2),
        },
        display: {
          xs: 'none',
          sm: 'block',
        },
      })}
    >
      |
    </Typography>
  );
};
